import { CommentItem, CommentNodeType } from '../interfaces';

export const normalizeCommentTree = (items: CommentItem[]): CommentNodeType[] => {
    const map = new Map<string, CommentNodeType>();

    items.forEach((item) => {
        map.set(item.id, { ...item, replies: [] });
        item.replies?.forEach((reply) => {
            if (!map.has(reply.id)) {
                map.set(reply.id, { ...reply, replies: [] });
            }
        });
    });

    items.forEach((item) => {
        const node = map.get(item.id);
        item.replies?.forEach((reply) => {
            const replyNode = map.get(reply.id);
            if (node && replyNode && !node.replies.some((existing) => existing.id === replyNode.id)) {
                node.replies.push(replyNode);
            }
        });
    });

    const roots: CommentNodeType[] = [];

    map.forEach((node) => {
        const parentId = node.parent?.id;
        if (parentId && map.has(parentId)) {
            const parent = map.get(parentId);
            if (parent && !parent.replies.some((reply) => reply.id === node.id)) {
                parent.replies.push(node);
            }
            return;
        }

        roots.push(node);
    });

    return roots.sort((a, b) => {
        const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return bTime - aTime;
    });
};
